import type { ReactNode } from 'react';
import { createContext, useContext, useMemo } from 'react';
import { useTiptapAiToken } from '../../../../../../hooks/useTiptapAiToken';

type AITokenContextType = {
  token?: string;
  shouldShowLoader: boolean;
};

export const AITokenContext = createContext<AITokenContextType | null>(null);

export const AITokenProvider = ({ children }: { children: ReactNode }) => {
  const { data: jwtToken, isLoading, isFetched } = useTiptapAiToken();

  const shouldShowLoader = isLoading && !isFetched;

  const value = useMemo(() => ({ token: jwtToken?.token, shouldShowLoader }), [jwtToken?.token, shouldShowLoader]);

  return <AITokenContext.Provider value={value}>{children}</AITokenContext.Provider>;
};

export const useAIToken = (preview?: boolean) => {
  const context = useContext(AITokenContext);
  // AI functionality should be disabled in preview mode
  if (preview) {
    return { token: undefined, shouldShowLoader: false };
  }
  if (!context) {
    throw new Error('useAIToken must be used within a AITokenProvider');
  }
  return context;
};
